import { render } from "./add.vue?vue&type=template&id=d8ed858c"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
script.render = render

export default script